export const galleryItems = [
  {
    id: 1,
    category: 'courts',
    src: 'https://public.readdy.ai/ai/img_res/edited_8c85ee8f741e462064d0db493a5f4bf3_24a1fddf.jpg',
    alt: 'Vue aérienne des 6 courts du TCD',
    altEn: 'Aerial view of TCD 6 courts',
    title: 'Complexe complet — 6 courts',
    titleEn: 'Full complex — 6 courts',
  },
  {
    id: 2,
    category: 'courts',
    src: 'https://public.readdy.ai/ai/img_res/edited_470f5314b7ec0fc57007fb91537ce2af_0d70550f.jpg',
    alt: 'Surface du court central',
    altEn: 'Center court surface',
    title: 'Court Central — Surface ITF',
    titleEn: 'Center Court — ITF Surface',
  },
  {
    id: 3,
    category: 'courts',
    src: 'https://public.readdy.ai/ai/img_res/edited_8863272915e591f51bfd2b179edc9c80_9c99fcf3.jpg',
    alt: 'Match de tournoi ITF J30',
    altEn: 'ITF J30 tournament match',
    title: 'ITF J30 — Match intense',
    titleEn: 'ITF J30 — Intense Match',
  },
  {
    id: 4,
    category: 'courts',
    src: 'https://public.readdy.ai/ai/img_res/edited_30662adaf352c5b16f62acca99c6d49a_676c873c.jpg',
    alt: "Cérémonie de remise des prix ITF",
    altEn: 'ITF award ceremony',
    title: 'Remise des prix — Champions ITF',
    titleEn: 'Awards Ceremony — ITF Champions',
  },
  {
    id: 5,
    category: 'courts',
    src: 'https://public.readdy.ai/ai/img_res/edited_3576fd9b6cae9cd58e61d9e69d3c4f22_4dcde8e3.jpg',
    alt: 'Séance de coaching adulte',
    altEn: 'Adult coaching session',
    title: 'Formation — Coaching adulte',
    titleEn: 'Training — Adult Coaching',
  },
  {
    id: 6,
    category: 'courts',
    src: 'https://public.readdy.ai/ai/img_res/edited_1040e0559cc517135c86247143790b31_74ebb137.jpg',
    alt: 'Formation coaching international',
    altEn: 'International coach training',
    title: 'Formation Coach — Niveau International',
    titleEn: 'Coach Training — International Level',
  },
  {
    id: 7,
    category: 'courts',
    src: 'https://public.readdy.ai/ai/img_res/edited_70a38c8cc4ddce2ca3e10514ca638ba3_24a1fddf.jpg',
    alt: 'Enfants au Kid Summer Camp',
    altEn: 'Kids at Summer Camp',
    title: 'Kid Summer Camp — Nos champions',
    titleEn: 'Kid Summer Camp — Our Champions',
  },
  {
    id: 8,
    category: 'courts',
    src: 'https://public.readdy.ai/ai/img_res/edited_cc20a260b59c5fa5c13fdceef2e5bf6d_24a1fddf.jpg',
    alt: 'Entraînement jeunes',
    altEn: 'Youth training',
    title: 'Entraînement Jeunes — Discipline & Fun',
    titleEn: 'Youth Training — Discipline & Fun',
  },
  {
    id: 9,
    category: 'courts',
    src: 'https://public.readdy.ai/ai/img_res/edited_6fcfeb37dc7976d1a5bb8c319f9b3c96_8431db00.jpg',
    alt: 'Soirée club TCD',
    altEn: 'TCD club evening',
    title: 'Soirée Membres — Sunset au TCD',
    titleEn: 'Members Night — Sunset at TCD',
  },
  {
    id: 10,
    category: 'courts',
    src: 'https://public.readdy.ai/ai/img_res/edited_b9fc95d72d4638efaf80c62e861129a2_3739e988.jpg',
    alt: "Cérémonie d'ouverture ITF",
    altEn: 'ITF opening ceremony',
    title: "Cérémonie d'Ouverture — Tournoi ITF",
    titleEn: 'Opening Ceremony — ITF Tournament',
  },
  {
    id: 11,
    category: 'coaching',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/daa7e753-bfb0-420d-b173-42d45878f4fb_1.jpeg',
    alt: 'Session éducative Kid Summer Camp',
    altEn: 'Kid Summer Camp educational session',
    title: 'Kid Summer Camp — Session en salle',
    titleEn: 'Kid Summer Camp — Classroom Session',
  },
  {
    id: 12,
    category: 'coaching',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/bec5a7a2-ab79-420b-9871-5c5496ac3a29_2.jpeg',
    alt: 'Entraînement sur les courts du TCD',
    altEn: 'Training on TCD courts',
    title: 'Entraînement collectif — Courts TCD',
    titleEn: 'Group Training — TCD Courts',
  },
  {
    id: 13,
    category: 'coaching',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/c1c14e0b-656b-4ecb-bf9f-45c79de7f2a7_3.jpeg',
    alt: 'Coaching personnalisé jeunes',
    altEn: 'Personalized youth coaching',
    title: 'Coaching personnalisé — Jeunes talents',
    titleEn: 'Personalized Coaching — Young Talents',
  },
  {
    id: 14,
    category: 'coaching',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/de04b291-835e-4edc-bdd4-025d6423145a_4.jpeg',
    alt: 'Apprentissage technique sur le court',
    altEn: 'Technical learning on court',
    title: 'Technique & Apprentissage — Court bleu',
    titleEn: 'Technique & Learning — Blue Court',
  },
  {
    id: 15,
    category: 'coaching',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/ffa8ba3b-7a58-4325-ac44-2f55c3e3affc_5.jpeg',
    alt: 'Groupe de jeunes joueurs du TCD',
    altEn: 'Group of young TCD players',
    title: 'Groupe de jeunes — Kid Summer Camp',
    titleEn: 'Youth Group — Kid Summer Camp',
  },
  {
    id: 16,
    category: 'coaching',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/e5ba92d9-45e3-43c7-9c8c-31956ef6c9eb_6.jpeg',
    alt: 'Cérémonie de certification Bernard Nkuh',
    altEn: 'Bernard Nkuh certification ceremony',
    title: 'Certification — Bernard Nkuh',
    titleEn: 'Certification — Bernard Nkuh',
  },
  {
    id: 17,
    category: 'coaching',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/ddf73352-ddb8-42a4-b40d-2b096201123e_7.jpeg',
    alt: 'Remise de certificat Bernard Nkuh',
    altEn: 'Bernard Nkuh certificate handover',
    title: 'Remise de certificat — Bernard Nkuh',
    titleEn: 'Certificate Handover — Bernard Nkuh',
  },
  {
    id: 18,
    category: 'coaching',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/c4cfe2bd-eb2c-42f8-8220-b008675a580e_8.jpeg',
    alt: 'Fin de formation coaching TOPSIC',
    altEn: 'TOPSIC coaching training completion',
    title: 'Fin de formation coaching — TOPSIC',
    titleEn: 'Coaching Training Completion — TOPSIC',
  },
  {
    id: 19,
    category: 'coaching',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/adbe51ac-e41b-49f7-8e7f-c6ab9cf67b30_9.jpeg',
    alt: 'Certification Kalla Daniel Paul',
    altEn: 'Kalla Daniel Paul certification',
    title: 'Certification — Kalla Daniel Paul',
    titleEn: 'Certification — Kalla Daniel Paul',
  },
  {
    id: 20,
    category: 'coaching',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/d3e5aeca-a4b8-4012-a8ba-7ae4ec90d60f_10.jpeg',
    alt: 'Équipe de coaches TOPSIC',
    altEn: 'TOPSIC coaching team',
    title: 'Équipe de coaches — TOPSIC',
    titleEn: 'Coaching Team — TOPSIC',
  },
  {
    id: 21,
    category: 'kids',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/ef5740accb5f7d0cb2f6d572b30afadc.jpeg',
    alt: 'Réunion éducative Kid Summer Camp',
    altEn: 'Kid Summer Camp educational meeting',
    title: 'Réunion éducative — Kid Summer Camp',
    titleEn: 'Educational Meeting — Kid Summer Camp',
  },
  {
    id: 22,
    category: 'kids',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/24f41cea917086adfa14c7a896fce52c.jpeg',
    alt: 'Vue aérienne entraînement enfants',
    altEn: 'Aerial view children training',
    title: "Vue d'ensemble — Entraînement enfants",
    titleEn: 'Overview — Children Training',
  },
  {
    id: 23,
    category: 'kids',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/d9c1b14c959926b42bc444231d310141.jpeg',
    alt: 'Apprentissage avec coach TCD',
    altEn: 'Learning with TCD coach',
    title: 'Apprentissage — Coach TCD',
    titleEn: 'Learning — TCD Coach',
  },
  {
    id: 24,
    category: 'kids',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/1b39a748a60c95f5e8e7ee3acd0daffe.jpeg',
    alt: 'Entraînement collectif jeunes',
    altEn: 'Group training youth',
    title: 'Entraînement collectif — Jeunes',
    titleEn: 'Group Training — Youth',
  },
  {
    id: 25,
    category: 'kids',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/80c9309278f521c3e38e8e0bd204d5c3.jpeg',
    alt: 'Groupe de champions Kid Summer Camp',
    altEn: 'Kid Summer Camp champions group',
    title: 'Nos champions — Kid Summer Camp',
    titleEn: 'Our Champions — Kid Summer Camp',
  },
  {
    id: 26,
    category: 'tournaments',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/b3725ba9-fbb7-4225-b936-48be1cf55b98_16.jpeg',
    alt: 'Tournoi International MTN ITF J30 Douala — Remise des médailles',
    altEn: 'MTN ITF J30 Douala International Tournament — Medal ceremony',
    title: 'ITF J30 — Remise des médailles',
    titleEn: 'ITF J30 — Medal Ceremony',
  },
  {
    id: 27,
    category: 'tournaments',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/7ab192c2-2d91-4c89-ab70-62aff0e5a076_17.jpeg',
    alt: 'Le sponsor officiel MTN — Cérémonie de remise des prix',
    altEn: 'Official MTN Sponsor — Awards ceremony',
    title: 'MTN — Sponsor officiel ITF J30',
    titleEn: 'MTN — Official ITF J30 Sponsor',
  },
  {
    id: 28,
    category: 'tournaments',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/4f6837d5-3edf-429c-b0af-35b2daed3e50_18.jpeg',
    alt: 'Finalistes ITF J30 Douala — Cérémonie de remise des prix',
    altEn: 'ITF J30 Douala finalists — Awards ceremony',
    title: 'Finalistes ITF J30 — Cérémonie',
    titleEn: 'ITF J30 Finalists — Ceremony',
  },
  {
    id: 29,
    category: 'tournaments',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/5d2f62de-77cb-4118-a3ed-24c2bf48db05_19.jpeg',
    alt: 'Cérémonie de remise des prix ITF J30 Douala',
    altEn: 'ITF J30 Douala awards ceremony',
    title: 'Cérémonie de remise des prix — ITF J30',
    titleEn: 'Awards Ceremony — ITF J30',
  },
  {
    id: 30,
    category: 'tournaments',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/f12bde40-0ab4-4fd8-854d-12ac56907827_20.jpeg',
    alt: 'Finalistes Double ITF J30 Douala — Champions avec trophées',
    altEn: 'ITF J30 Douala Doubles Finalists — Champions with trophies',
    title: 'Finalistes Double — Champions ITF J30',
    titleEn: 'Doubles Finalists — ITF J30 Champions',
  },
  {
    id: 31,
    category: 'tournaments',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/1d30c06e-c259-4278-8cc1-df09ad9231e0_21.jpeg',
    alt: 'Le collectif de champion ITF J30 Douala — Photo de groupe',
    altEn: 'ITF J30 Douala Champions Collective — Group photo',
    title: 'Collectif de champion — ITF J30',
    titleEn: 'Champions Collective — ITF J30',
  },
  {
    id: 32,
    category: 'tournaments',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/88f40d89-61d7-4401-a3dd-2861bb64649e_22.jpeg',
    alt: 'Organisateurs et officiels du tournoi ITF J30 Douala',
    altEn: 'Organizers and officials of ITF J30 Douala tournament',
    title: 'Officiels et organisateurs — ITF J30',
    titleEn: 'Officials and Organizers — ITF J30',
  },
  {
    id: 33,
    category: 'tournaments',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/bde2a3d5-1a3c-4d78-a695-ae11f6f92169_23.jpeg',
    alt: 'Équipe organisatrice du tournoi ITF J30 Douala sur le court',
    altEn: 'ITF J30 Douala tournament organizing team on court',
    title: 'Équipe organisatrice — ITF J30',
    titleEn: 'Organizing Team — ITF J30',
  },
  {
    id: 34,
    category: 'tournaments',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/b6b96f56-aff7-4932-bc01-6f5f413aa4e6_24.jpeg',
    alt: 'Vainqueur Double ITF J30 Douala — Champions avec trophées',
    altEn: 'ITF J30 Douala Doubles Winners — Champions with trophies',
    title: 'Vainqueur Double — ITF J30',
    titleEn: 'Doubles Winners — ITF J30',
  },
  {
    id: 35,
    category: 'tournaments',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/908e550b-782d-4441-b95e-7bbb1312e3c5_25.jpeg',
    alt: 'Finalistes ITF J30 Douala — Champions et trophées',
    altEn: 'ITF J30 Douala Finalists — Champions and trophies',
    title: 'Champions ITF J30 — Douala',
    titleEn: 'ITF J30 Champions — Douala',
  },
  {
    id: 36,
    category: 'events',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/0d5a1876cfe0dd9d8a08e4003f2c5656.jpeg',
    alt: 'Kid Summer Camp 2026 — Programme estival du Tennis Club de Douala',
    altEn: 'Kid Summer Camp 2026 — Tennis Club de Douala summer program',
    title: 'Kid Summer Camp 2026',
    titleEn: 'Kid Summer Camp 2026',
  },
  {
    id: 37,
    category: 'events',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/15149028038e4de99444dbc7be6d8bee.jpeg',
    alt: 'Équipe TOPSIC et organisateurs du tournoi ITF J30 Douala',
    altEn: 'TOPSIC team and ITF J30 Douala tournament organizers',
    title: 'Équipe TOPSIC — ITF J30 Douala',
    titleEn: 'TOPSIC Team — ITF J30 Douala',
  },
  {
    id: 38,
    category: 'all',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/d42d390858ed0f544dceee1446a69d27.jpeg',
    alt: 'Joueurs au filet avec coach sur le court TCD',
    altEn: 'Players at the net with coach on TCD court',
    title: 'Coach et joueurs au filet — TCD',
    titleEn: 'Coach and players at the net — TCD',
  },
  {
    id: 39,
    category: 'all',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/a23db12d5d2bc124f0d442ad20f78324.jpeg',
    alt: 'Joueur au service sur le court du TCD',
    altEn: 'Player serving on TCD court',
    title: 'Service — Court du TCD',
    titleEn: 'Serve — TCD Court',
  },
  {
    id: 40,
    category: 'all',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/49b39e56083adb4088d3dd695170a9af.jpeg',
    alt: 'Discours officiel lors de la cérémonie ITF J30',
    altEn: 'Official speech during ITF J30 ceremony',
    title: 'Discours officiel — Cérémonie ITF J30',
    titleEn: 'Official speech — ITF J30 Ceremony',
  },
  {
    id: 41,
    category: 'all',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/3b78703d074fd28da4a742fc1d15e8e0.jpeg',
    alt: 'Joueuses juniors au filet pendant le tournoi ITF',
    altEn: 'Junior players at the net during ITF tournament',
    title: 'Joueuses au filet — ITF J30 Douala',
    titleEn: 'Players at the net — ITF J30 Douala',
  },
  {
    id: 42,
    category: 'all',
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/8f1ac1214a2ca882efe37463c72a0655.jpeg',
    alt: 'Réunion de formation des coaches en salle de classe',
    altEn: 'Coach training meeting in classroom',
    title: 'Formation coaching — Salle de classe',
    titleEn: 'Coach Training — Classroom',
  },
  {
    id: 43,
    category: 'all',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/0ccb42e6-ab0b-4433-aa7e-56eae56f7b13_26.jpeg',
    alt: 'Joueur en position de coup droit sur le court TCD',
    altEn: 'Player in forehand position on TCD court',
    title: 'Coup droit — Entraînement TCD',
    titleEn: 'Forehand — TCD Training',
  },
  {
    id: 44,
    category: 'all',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/35b48423-9b11-40a1-84e2-71f6be4f39e2_27.jpeg',
    alt: 'Groupe de joueurs et coaches célébrant au TCD',
    altEn: 'Group of players and coaches celebrating at TCD',
    title: 'Célébration — Équipe TCD',
    titleEn: 'Celebration — TCD Team',
  },
  {
    id: 45,
    category: 'all',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/ed8a2f56-36a1-4490-baff-c6e7c1be88ab_28.jpeg',
    alt: 'Groupe de joueurs et famille avec trophée au TCD',
    altEn: 'Group of players and family with trophy at TCD',
    title: 'Champions avec famille — TCD',
    titleEn: 'Champions with family — TCD',
  },
  {
    id: 46,
    category: 'all',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/b805b254-0d0b-4159-87ab-57edf1067d81_29.jpeg',
    alt: 'Deux joueurs posant au filet avec leurs raquettes',
    altEn: 'Two players posing at the net with their rackets',
    title: 'Deux joueurs au filet — TCD',
    titleEn: 'Two players at the net — TCD',
  },
  {
    id: 47,
    category: 'all',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/0c6803ec-9bfb-48d3-8827-b6978aad3490_30.jpeg',
    alt: 'Cérémonie de remise des prix avec les lauréats ITF',
    altEn: 'Awards ceremony with ITF laureates',
    title: 'Remise des prix — Lauréats ITF',
    titleEn: 'Awards ceremony — ITF Laureates',
  },
  {
    id: 48,
    category: 'all',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/183b0c27-62b2-4bc3-95fa-63e4e76e2c61_31.jpeg',
    alt: 'Officiels et organisateurs sur le court du TCD',
    altEn: 'Officials and organizers on TCD court',
    title: 'Officiels — Cérémonie TCD',
    titleEn: 'Officials — TCD Ceremony',
  },
  {
    id: 49,
    category: 'all',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/d56a1000-b8f9-4384-9d47-d3a39183dfd5_32.jpeg',
    alt: 'Groupe de joueurs et coaches sur le court TCD',
    altEn: 'Group of players and coaches on TCD court',
    title: 'Équipe complète — TCD',
    titleEn: 'Full Team — TCD',
  },
  {
    id: 50,
    category: 'all',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/2e757bad-2529-4838-806d-c8773f0ed43b_33.jpeg',
    alt: 'Joueurs et officiels en tenue sportive sur le court',
    altEn: 'Players and officials in sportswear on court',
    title: 'Joueurs et officiels — TCD',
    titleEn: 'Players and Officials — TCD',
  },
  {
    id: 51,
    category: 'all',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/2d9b1cf5-24ba-413b-b9de-9dfc87e23fa8_34.jpeg',
    alt: 'Joueur junior en action sur le court devant les spectateurs',
    altEn: 'Junior player in action on court in front of spectators',
    title: 'Joueur en action — ITF J30',
    titleEn: 'Player in action — ITF J30',
  },
  {
    id: 52,
    category: 'all',
    src: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/d68a9009-a331-4865-84eb-1484911f44b5_35.jpeg',
    alt: 'Match en double sur le court bleu du TCD',
    altEn: 'Doubles match on TCD blue court',
    title: 'Double — Match compétitif TCD',
    titleEn: 'Doubles — Competitive match TCD',
  },
];

export const galleryCategories = [
  { id: 'all', key: 'gallery.all' },
  { id: 'courts', key: 'gallery.courts' },
  { id: 'tournaments', key: 'gallery.tournaments' },
  { id: 'coaching', key: 'gallery.coaching' },
  { id: 'kids', key: 'gallery.kids' },
  { id: 'events', key: 'gallery.events' },
];